import LoadingStatus from '@libs/loading-status';

import {
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_FAILURE,
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type LoadingStatusState = LoadingStatus;

const initialState: LoadingStatusState = LoadingStatus.IDLE;
export default function reducer(
  state: LoadingStatusState = initialState,
  action: ContractSetupAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_REQUEST:
      return LoadingStatus.PENDING;
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_SUCCESS:
      return LoadingStatus.SUCCEEDED;
    case CONTRACT_SETUP__DOCUMENT_AUTHENTICATIONS_FETCH_FAILURE:
      return LoadingStatus.FAILED;
    default:
      return state;
  }
}
